import React from "react";
import "./AboutContent.css";

function Content2025() {
  return (
    <>
      <section className="hero">
        <div className="heading">
          <h1>Productions</h1>
          <h3>
            <a href="/productions">Current Productions</a> -{" "}
            <a href="/2024productions">2024</a> -{" "}
            <a href="/2025productions">2025</a> -{" "}
            <a href="/2026productions">2026</a>
          </h3>
        </div>
      </section>

      <br></br>
      <div className="container reverse-order">
        <div className="hero-image-left">
          <img src="images/setinchicago2.jpg" alt="littlehelp" />
        </div>
        <div className="hero-content">
          <h2>Set in Chicago: Holiday Style</h2>
          <h3>Improv Comedy</h3>
          <h4>Donny's Skybox Theater</h4>
        </div>
      </div>

      <br></br>

      <div className="container">
        <div className="hero-content">
          <h2>Thanksgiving Leftovers</h2>
          <h3>Sketch Comedy</h3>
          <h4>Judy's Beat Lounge @ Second City</h4>
        </div>
        <div className="hero-image-left">
          <img src="images/thanksgiving.jpg" alt="history" />
        </div>
      </div>

      <br></br>
      <div className="container reverse-order">
        <div className="hero-image-left">
          <img src="images/hallowseve.jpg" alt="littlehelp" />
        </div>
        <div className="hero-content">
          <h2>All Hallows' Eve</h2>
          <h3>Improv Comedy</h3>
          <h4>Annoyance Theater</h4>
        </div>
      </div>
      <br></br>

      <div className="container">
        <div className="hero-content">
          <h2>Oops! All Bits</h2>
          <h3>Sketch Comedy</h3>
          <h4>Judy's Beat Lounge @ Second City</h4>
        </div>
        <div className="hero-image-left">
          <img src="images/oops.jpg" alt="history" />
        </div>
      </div>

      <br></br>
      <div className="container reverse-order">
        <div className="hero-image-left">
          <img src="images/olympus.jpg" alt="littlehelp" />
        </div>
        <div className="hero-content">
          <h2>Olympus Has Fallen</h2>
          <h3>Sketch Comedy</h3>
          <h4>de Maat Studio Theatre @ Second City</h4>
        </div>
      </div>

      <br></br>

      <div className="container">
        <div className="hero-content">
          <h2>Set in Chicago</h2>
          <h3>Improv Show</h3>
          <h4>de Maat Studio Theater @ Second City</h4>
        </div>
        <div className="hero-image-left">
          <img src="images/setinchicago.jpg" alt="history" />
        </div>
      </div>

      <br></br>

      <div className="container reverse-order">
        <div className="hero-image-left">
          <img src="images/touristtrap2.jpg" alt="littlehelp" />
        </div>
        <div className="hero-content">
          <h2>Tourist Trap</h2>
          <h3>Improv Horror Comedy</h3>
          <h4>de Maat Studio Theatre @ Second City</h4>
        </div>
      </div>

      <br></br>

      <div className="container">
        <div className="hero-content">
          <h2>Prov Ur Luv 2 Me</h2>
          <h3>Improv Dating Show</h3>
          <h4>de Maat Studio Theater @ Second City</h4>
        </div>
        <div className="hero-image-left">
          <img src="images/provelove2.jpg" alt="history" />
        </div>
      </div>

      <br></br>
      <div className="container reverse-order">
        <div className="hero-image-left">
          <img src="images/littlehelp.jpg" alt="littlehelp" />
        </div>
        <div className="hero-content">
          <h2>With a Little Help From our Friends</h2>
          <h3>Sketch Comedy</h3>
          <h4>de Maat Studio Theatre @ Second City</h4>
        </div>
      </div>
      <br></br>
      <div className="container">
        <div className="hero-content">
          <h2>Tourist Trap</h2>
          <h3>Improv Horror Story</h3>
          <h4>Donny's Skybox Theater @ Second City</h4>
        </div>
        <div className="hero-image-left">
          <img src="images/touristtrap.jpg" alt="history" />
        </div>
      </div>
      <br></br>
      <div className="container reverse-order">
        <div className="hero-image-left">
          <img src="images/propkids_march.jpg" alt="kittyandkellie" />
        </div>
        <div className="hero-content">
          <h2>The Propular Kidz</h2>
          <h3>Improv Comedy</h3>
          <h4>Judy's Beat Lounge @ Second City</h4>
        </div>
      </div>
      <br></br>
      <div className="container">
        <div className="hero-content">
          <h2>History Reheats Itself</h2>
          <h3>Sketch Comedy</h3>
          <h4>Judy's Beat Lounge @ Second City</h4>
        </div>
        <div className="hero-image-left">
          <img src="images/history.jpg" alt="history" />
        </div>
      </div>

      <br></br>

      <div className="container reverse-order">
        <div className="hero-image-left">
          <img src="images/bloodyvalentine.jpg" alt="bloodyvalentine" />
        </div>
        <div className="hero-content">
          <h2>Bloody Valentine</h2>
          <h3>Improvized Horror Comedy</h3>
          <h4>IO Theater</h4>
        </div>
      </div>

      <br></br>
      <div className="container">
        <div className="hero-content">
          <h2>Prov Ur Love 2 Me</h2>
          <h3>Improv Comedy</h3>
          <h4>Blackout Carabet @ Second City</h4>
        </div>
        <div className="hero-image-left">
          <img src="images/provlove.jpg" alt="provlove" />
        </div>
      </div>

      <br></br>

      <div className="container reverse-order">
        <div className="hero-image-left">
          <img src="images/kittyandkellie.png" alt="kittyandkellie" />
        </div>
        <div className="hero-content">
          <h2>The Kitty and Kellie Show</h2>
          <h3>Improv/Sketch Comedy</h3>
          <h4>Judy's Beat Lounge @ Second City</h4>
        </div>
      </div>

      <br></br>
      <div className="container">
        <div className="hero-content">
          <h2>Puff, Puff, Laugh (Vol. 2)</h2>
          <h3>Sketch Comedy</h3>
          <h4>The Annoyance Theater</h4>
        </div>
        <div className="hero-image">
          <img src="images/puffpuffvol2.png" alt="puffpuffposter2" />
        </div>
      </div>
      <br></br>
      <div className="container reverse-order">
        <div className="hero-image-left">
          <img src="images/snowedin.jpg" alt="snowedin" />
        </div>
        <div className="hero-content">
          <h2>Snowed In</h2>
          <h3>Improv Comedy</h3>
          <h4>Judy's Beat Lounge @ Second City</h4>
        </div>
      </div>
    </>
  );
}

export default Content2025;
